import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { FeatureFlagService, FeatureFlag } from '../services/feature-flag';

/**
 * Route guard factory that prevents access to experimental routes
 * when the corresponding feature flag is disabled.
 *
 * Usage in route config:
 *   { path: 'domain-topics', component: ..., canActivate: [AuthGuard, featureFlagGuard('domainTopics')] }
 *
 * Redirects to /dashboard if the flag is off.
 */
export function featureFlagGuard(flag: FeatureFlag): CanActivateFn {
  return () => {
    const featureFlags = inject(FeatureFlagService);
    const router = inject(Router);

    if (featureFlags.isEnabled(flag)) {
      return true;
    }

    return router.createUrlTree(['/dashboard']);
  };
}

